var _path, _g, _g2, _path2, _path3, _path4, _g3, _path5, _path6, _g4, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g5, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphicsLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 366,
    height: 99,
    viewBox: "0 0 366 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_449)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M-71 267.02C-14.83 148.41 93.64 -6.96 171.52 -112C184.24 -53.09 197.25 8.63 207.51 69.25C213.27 62.79 219.06 56.36 224.9 49.98C258.14 14.14 328.24 -59.79 365.46 -91.64C340.77 -38.24 274.66 50.81 243.42 100.49C225.16 129.65 196.97 170.32 177.62 199.4L161.99 137.99C153.17 103.17 145.22 68.15 137.95 32.99C117.83 57.28 97.2 81.19 75.98 104.64C39.16 144.9 -29.29 231.38 -71 267.02Z",
    fill: "#9B49FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_48_449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.909 43.8023C162.563 54.7535 180.358 67.7941 192.883 76.4299C192.065 69.4637 191.178 62.1723 190.026 55.1045C190.906 55.6016 191.787 56.0888 192.668 56.5759C197.676 59.2706 208.186 64.7816 213.482 66.8934C208.748 61.9416 198.123 54.6196 192.806 50.322C189.701 47.799 185.06 44.3762 181.84 41.906L182.433 49.2587C182.768 53.4286 183.214 57.5854 183.731 61.7268C180.597 59.8032 177.429 57.9475 174.206 56.1684C168.639 53.1175 157.84 46.1651 151.908 43.8122L151.909 43.8023Z",
    fill: "#E7DD21"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_48_449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7522 27.5293L31.2229 39.7522L19 22.2229L36.5293 10L48.7522 27.5293ZM32.1086 34.7459L43.7402 26.6354L35.6297 15.0039L23.9982 23.1143L32.1086 34.7459Z",
    fill: "#E272FA"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_48_449)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M332.801 22.197C328.804 25.3721 323.734 26.8793 320.268 27.7376C318.918 28.0699 317.538 28.3783 316.204 28.6714C311.604 29.6847 307.28 30.6415 303.368 32.7724C302.474 33.262 301.602 33.839 300.774 34.497C297.05 37.4544 294.967 41.2981 295.025 44.9788L293.021 45.2688C292.846 40.8781 295.202 36.3452 299.487 32.9423C300.412 32.2075 301.392 31.5549 302.404 31.0027C306.569 28.7339 311.236 27.7047 315.743 26.7072C317.068 26.416 318.441 26.1127 319.785 25.7798C324.94 24.5047 328.789 22.8175 331.558 20.6181C332.712 19.7014 333.713 18.6648 334.525 17.5424C337.779 13.0473 339.354 4.14839 333.093 -6.13736C327.622 -15.1241 318.671 -21.9191 308.539 -24.7793C298.404 -27.6369 287.213 -26.5221 277.828 -21.7238C274.943 -20.246 272.122 -18.4038 269.201 -16.084C264.836 -12.6171 260.895 -8.61588 256.725 -4.38023C252.698 -0.289342 248.539 3.93285 243.968 7.56364C241.94 9.1742 239.996 10.5396 238.024 11.7437C226.058 19.0381 210.902 21.0189 197.48 17.0405C184.056 13.0679 172.444 3.15357 166.418 -9.47664C163.851 -14.8598 161.283 -22.9716 163.65 -31.0397C165.151 -36.153 168.45 -40.7629 173.454 -44.7368C174.189 -45.3206 174.966 -45.8908 175.758 -46.4301C181.192 -50.1324 187.362 -52.5185 193.323 -54.823L219.274 -64.858L219.997 -62.9811L194.046 -52.9461C188.189 -50.6825 182.133 -48.3391 176.886 -44.7647C176.132 -44.2503 175.394 -43.7109 174.694 -43.1552C170.029 -39.4502 166.963 -35.1826 165.578 -30.4718C164.371 -26.3527 163.851 -19.5205 168.231 -10.3388C174.016 1.78394 185.165 11.3058 198.049 15.1234C210.937 18.9443 225.486 17.0409 236.974 10.0375C238.864 8.88258 240.738 7.56771 242.701 6.00836C247.195 2.43903 251.304 -1.73321 255.279 -5.77156C259.289 -9.84387 263.426 -14.0481 267.962 -17.6508C271.008 -20.0704 273.935 -21.9856 276.91 -23.5088C286.738 -28.5377 298.467 -29.7025 309.081 -26.7112C319.698 -23.7168 329.075 -16.5981 334.807 -7.18352C339.043 -0.228547 341.932 10.7302 336.149 18.7196C335.235 19.9857 334.105 21.151 332.796 22.1906L332.801 22.197Z",
    fill: "#E7DD21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M275.596 78.4564L281.51 82.0104C282.011 82.3104 282.642 82.3969 283.329 82.2086L277.415 78.6547C276.731 78.8462 276.097 78.7564 275.596 78.4564Z",
    fill: "#A56E00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_48_449",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 275,
    y: 78,
    width: 9,
    height: 5
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M275.596 78.4564L281.51 82.0104C282.011 82.3104 282.642 82.3969 283.329 82.2086L277.415 78.6547C276.731 78.8462 276.097 78.7564 275.596 78.4564Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_48_449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.596 78.4564L281.51 82.0104C282.011 82.3104 282.642 82.3969 283.329 82.2086L277.415 78.6547C276.731 78.8462 276.097 78.7564 275.596 78.4564Z",
    fill: "#A56E00"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M354.284 29.4002L348.37 25.8462C349.035 26.2469 349.469 27.0253 349.473 28.0299L355.388 31.5839C355.384 30.5793 354.949 29.8009 354.284 29.4002Z",
    fill: "#A56E00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_48_449",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 348,
    y: 25,
    width: 8,
    height: 7
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M354.284 29.4002L348.37 25.8462C349.035 26.2469 349.469 27.0253 349.473 28.0299L355.388 31.5839C355.384 30.5793 354.949 29.8009 354.284 29.4002Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_48_449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.476 28.0332L355.39 31.5872C355.386 30.5826 354.952 29.8042 354.287 29.4035L348.373 25.8496C349.038 26.2503 349.472 27.0286 349.476 28.0332Z",
    fill: "#A56E00"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M277.412 78.6514L283.329 82.2028L352.674 62.8862L346.76 59.3323L277.412 78.6514Z",
    fill: "#A56E00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M349.641 55.3333L355.558 58.8847L355.39 31.5871L349.476 28.0331L349.641 55.3333Z",
    fill: "#A56E00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M277.209 44.9678C275.608 45.415 274.315 47.2087 274.325 48.9693L274.49 76.2695C274.5 78.0301 275.812 79.0986 277.412 78.6514L346.757 59.3348C348.358 58.8876 349.651 57.0939 349.641 55.3333L349.476 28.0331C349.466 26.2725 348.154 25.204 346.554 25.6512L277.209 44.9678Z",
    fill: "#E7DD21"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M346.58 58.0529C347.572 57.6741 348.374 56.4597 348.368 55.3466L348.204 28.0463C348.202 27.5749 348.048 27.1884 347.784 26.9886C347.501 26.7778 347.146 26.8134 346.9 26.8821L277.556 46.1987C277.501 46.2159 277.446 46.2331 277.394 46.2536C276.402 46.6324 275.6 47.8467 275.606 48.9599L275.77 76.2601C275.772 76.7316 275.926 77.118 276.19 77.3179C276.473 77.5287 276.829 77.493 277.074 77.4243L346.418 58.1077C346.473 58.0905 346.528 58.0733 346.58 58.0529Z",
    fill: "#D6B700"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M347.782 26.9854C347.498 26.7746 347.143 26.8102 346.898 26.8789L332.92 30.7738C331.37 32.7929 329.643 34.6837 327.87 36.4491C318.786 45.4855 307.551 51.6745 296.336 57.6317C289.598 61.2149 282.73 64.6223 275.719 67.6767L275.771 76.2543C275.772 76.7258 275.927 77.1123 276.191 77.3121C276.474 77.5229 276.829 77.4873 277.074 77.4186L346.419 58.1019C346.474 58.0847 346.528 58.0676 346.581 58.0471C347.573 57.6683 348.375 56.4539 348.369 55.3408L348.204 28.0406C348.203 27.5691 348.049 27.1826 347.785 26.9828L347.782 26.9854Z",
    fill: "#AA5D2F"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M346.76 59.3323L352.674 62.8862C354.275 62.439 355.568 60.6454 355.558 58.8847L349.644 55.3308C349.654 57.0914 348.361 58.8851 346.76 59.3323Z",
    fill: "#A56E00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_48_449",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 346,
    y: 55,
    width: 10,
    height: 8
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M346.76 59.3323L352.674 62.8862C354.275 62.439 355.568 60.6454 355.558 58.8847L349.644 55.3308C349.654 57.0914 348.361 58.8851 346.76 59.3323Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_48_449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.76 59.3323L352.674 62.8862C352.889 62.8258 353.098 62.7442 353.297 62.6381L347.383 59.0841C347.184 59.1902 346.975 59.2718 346.76 59.3323Z",
    fill: "#A56E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.383 59.0841L353.297 62.6381C353.553 62.5032 353.798 62.335 354.026 62.1384L348.111 58.5844C347.884 58.781 347.639 58.9493 347.383 59.0841Z",
    fill: "#A56E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.111 58.5844L354.026 62.1384C354.943 61.347 355.566 60.1064 355.558 58.8847L349.644 55.3308C349.652 56.5525 349.029 57.793 348.111 58.5844Z",
    fill: "#A56E00"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M292.43 49.1393L292.468 51.3245C292.486 52.4801 293.595 53.3002 294.709 52.982L296.472 52.48C297.583 52.1645 298.691 52.9845 298.713 54.1375L298.794 58.7663C298.807 59.5641 298.283 60.2686 297.514 60.4913L293.953 61.5087C293.187 61.7288 292.66 62.4359 292.673 63.2337L292.744 67.2875C292.757 68.0853 292.234 68.7898 291.464 69.0125L287.425 70.1686C286.314 70.4842 285.205 69.6641 285.183 68.5111L285.146 66.3259C285.127 65.1703 284.018 64.3502 282.904 64.6683L281.138 65.1729C280.027 65.4885 278.919 64.6684 278.897 63.5154L278.816 58.8867C278.803 58.0889 279.327 57.3844 280.096 57.1617L283.66 56.1417C284.426 55.9216 284.953 55.2145 284.94 54.4167L284.869 50.3629C284.856 49.5651 285.379 48.8606 286.149 48.6379L290.188 47.4818C291.299 47.1662 292.408 47.9863 292.43 49.1393Z",
    fill: "#3D3206"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M337.983 36.1747L338.02 38.3599C338.039 39.5155 339.148 40.3356 340.262 40.0174L342.024 39.5154C343.135 39.1999 344.244 40.0199 344.266 41.1729L344.346 45.8017C344.36 46.5995 343.836 47.304 343.067 47.5267L339.506 48.5441C338.74 48.7642 338.213 49.4713 338.226 50.2691L338.297 54.3229C338.31 55.1207 337.787 55.8252 337.017 56.0479L332.978 57.204C331.867 57.5196 330.758 56.6995 330.736 55.5465L330.698 53.3613C330.679 52.2057 329.571 51.3856 328.457 51.7038L326.691 52.2083C325.58 52.5239 324.471 51.7038 324.449 50.5508L324.369 45.9221C324.356 45.1243 324.879 44.4198 325.649 44.1971L329.213 43.1771C329.979 42.957 330.506 42.2499 330.493 41.4521L330.422 37.3983C330.409 36.6005 330.932 35.896 331.702 35.6733L335.741 34.5172C336.852 34.2016 337.961 35.0217 337.983 36.1747Z",
    fill: "#3D3206"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M288.551 49.2334L291.075 51.2392L286.121 52.6542L288.551 49.2334Z",
    fill: "#FFE133"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M286.337 66.403L291.288 64.9847L288.861 68.4087L286.337 66.403Z",
    fill: "#FFE133"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M282.39 57.7858L282.483 63.2181L279.959 61.2124L282.39 57.7858Z",
    fill: "#FFE133"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M294.923 54.23L297.446 56.2357L295.019 59.6598L294.923 54.23Z",
    fill: "#FFE133"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M334.245 36.5454C335.338 36.2336 336.242 36.9484 336.261 38.1509C336.281 39.3534 335.413 40.5778 334.32 40.8896C333.227 41.2014 332.323 40.4808 332.304 39.2841C332.284 38.0874 333.154 36.8604 334.245 36.5454Z",
    fill: "#FFE133"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M334.488 50.5666C335.581 50.2548 336.485 50.9696 336.504 52.1721C336.524 53.3745 335.656 54.599 334.563 54.9108C333.47 55.2225 332.566 54.5019 332.547 53.3053C332.527 52.1086 333.397 50.8815 334.488 50.5666Z",
    fill: "#FFE133"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M327.974 45.384C329.067 45.0722 329.971 45.787 329.991 46.9895C330.01 48.1919 329.142 49.4164 328.049 49.7282C326.956 50.0399 326.053 49.3194 326.033 48.1227C326.013 46.926 326.884 45.6989 327.974 45.384Z",
    fill: "#FFE133"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M340.759 41.728C341.852 41.4162 342.756 42.131 342.775 43.3335C342.794 44.536 341.927 45.7604 340.834 46.0722C339.741 46.3839 338.837 45.6634 338.817 44.4667C338.797 43.27 339.668 42.043 340.759 41.728Z",
    fill: "#FFE133"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_48_449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.88 86.35L72 71.88L86.47 52L106.35 66.47L91.88 86.35ZM77.78 70.97L90.97 80.57L100.57 67.38L87.38 57.78L77.78 70.97Z",
    fill: "#BDE7FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436.46,
    height: 379.02,
    fill: "white",
    transform: "translate(-71 -112)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_48_449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.76,
    height: 62.92,
    fill: "white",
    transform: "translate(214.944 44.01) rotate(93.6541)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_48_449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.37,
    height: 21.37,
    fill: "white",
    transform: "translate(19 22.2229) rotate(-34.8874)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_48_449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 196,
    fill: "white",
    transform: "translate(151 -26.9027) rotate(-38.4586)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_48_449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.35,
    height: 34.35,
    fill: "white",
    transform: "translate(72 52)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicsLeft);
export default __webpack_public_path__ + "static/media/graphics-left.b5fbe4b80a16a256f5ef21eede8640e9.svg";
export { ForwardRef as ReactComponent };